import { reactive } from 'vue';

export const criarDocAnulacao = () => {
    return reactive({
        id: 0,
        idep: 0,
        idsim: 0,
        idestabelecimento: 0,
        idanexo: 0,
        subtipo: '',
        protocolo: '',
        dtregistro: '',
        informacoes: '',
        dhprotocolo: '',
        idprotocolo: 0,
        dhhomologacao: '',
        idhomologacao: 0,
        ckhomologacao: '',
        jshomologacao: '',
        cdperfil: 0,
        nmperfil: '',
        cdstatus: 0,
        nmstatus: '',
        refid: 0,
        reftabela: '',
        refidentificacao: '',
        refdtperiodo: '',
        refprotocolo: '',
        idlogin: 0,
        idusuario: 0
    });
};